import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class IntraOne_ds_get_primary_pick_location_by_material_id_packaging_id_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async get($inParams: { material_id?: number, packaging_id?: number }): Promise<{ result?: { id?: number, name?: string } }> {
    let $url = `${environment.backendUrl}api/IntraOne/datasources/ds_get_primary_pick_location_by_material_id_packaging_id_flow/get`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      material_id?: number, packaging_id?: number    }) {
      return false;
    }
}
